import { makeAuthedRequest } from "utils/makeAuthedRequest";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { useState, useEffect } from "react";

export function useMembership(_prefetch) {
  const queryClient = useQueryClient();

  const [prefetch, setPrefetch] = useState(_prefetch || null);
  useEffect(() => {
    console.log(_prefetch)
    _prefetch ? setPrefetch(_prefetch) : setPrefetch(null);
  }, [_prefetch]);

  const { data, status, isLoading, refetch, isRefetching } = useQuery(
    ["subscriptions"],
    () =>
      makeAuthedRequest(
        `v1/settings/subscription/all${
          prefetch ? `?precheck=${prefetch}` : ""
        }`,
        {
          method: "GET",
        }
      ).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      }),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  useEffect(() => {
    refetch();
  }, [prefetch]);

  const scheduleChange = useMutation(
    (type) =>
      makeAuthedRequest(`v1/settings/schedule/${type}`, {
        method: "GET",
      }).then(async (res) => {
        if (res.ok) {
          return res;
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      }),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  const cancelScheduledChange = useMutation(
    () =>
      makeAuthedRequest(`v1/settings/schedule/cancel`, {
        method: "PUT",
      }).then(async (res) => {
        if (res.ok) {
          return res;
        } else {
          const body = await res.json();
          throw new Error(body.error);
        }
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["subscriptions"]);
      },
      onError: (error) => {
        console.error("Membership cancellation failed:", error);
      },
    }
  );

  return {
    data,
    status,
    isLoading,
    refetch,
    scheduleChange,
    cancelScheduledChange,
    isRefetching
  };
}

export function useProcessPost() {
  const queryClient = useQueryClient();

  const processPost = useMutation(
    async (membershipData) => {
      try {
        const res = await makeAuthedRequest("v1/settings/process", {
          method: "POST",
          body: JSON.stringify(membershipData),
        });
        if (res.ok) {
          return await res.json();
        } else {
          const body = await res.json();
          throw new Error(body?.error?.message);
        }
      } catch (error) {
        console.error("Error in processPost mutation:", error);
        throw error;
      }
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["subscriptions"]);
        queryClient.invalidateQueries("issues");
      },
      onError: (error) => {
        console.error("processPost mutation failed:", error);
      },
    }
  );

  return {
    processPost,
  };
}

export function useResources() {
  const { data, isLoading, refetch } = useQuery(
    ["resources"],
    () =>
      makeAuthedRequest("v1/settings/resources", {
        method: "GET",
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      }),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  return {
    data,
    isLoading,
    refetch,
  };
}
